module.exports = __webpack_public_path__ + "img/delivery-period.6e30da8.svg";